import { forwardRef } from 'react'

import { tv, type VariantProps } from 'tailwind-variants'

import { cn } from '../../../utils/cn'

const iconVariants = tv({
  base: 'material-symbols-rounded inline-flex select-none leading-none',
  variants: {
    size: {
      xs: 'text-xs',
      sm: 'text-sm',
      md: 'text-lg',
      lg: 'text-2xl',
      xl: 'text-3xl',
      inherit: 'size-[1em] text-[1lh]'
    }
  },
  defaultVariants: {
    size: 'inherit'
  }
})

export type IconProps = VariantProps<typeof iconVariants> & {
  name: string
  className?: string
} & Omit<React.ComponentPropsWithRef<'span'>, 'children'>

export const Icon = forwardRef<HTMLSpanElement, IconProps>(
  ({ name, size, className, ...props }, ref) => (
    <span
      ref={ref}
      data-slot='icon'
      className={cn(iconVariants({ size }), className)}
      {...props}
    >
      {name}
    </span>
  )
)
Icon.displayName = 'Icon'
